import { supabase } from '../supabaseClient';

export async function requestBrokeredContact({ daId, role, message }) {
  if (!daId) throw new Error('Missing DA id');
  if (!role) throw new Error('Missing contact role');

  const { data, error } = await supabase.functions.invoke('request-brokered-contact', {
    body: { daId, role, message },
  });

  if (error) {
    throw new Error(error.message || 'Could not request introduction');
  }
  if (data?.error) {
    throw new Error(data.error);
  }
  return data;
}
